import Vue from 'vue'
import Vuex from 'vuex'
import system from '@/store/system'
import user from '@/store/user'
import search from "@/store/search";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        user: JSON.parse(localStorage.getItem('user')) || {}
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user
            localStorage.setItem('user', JSON.stringify(user))
        },
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_REFRESH_TOKEN(state, refreshToken) {
            state.refreshToken = refreshToken
            localStorage.setItem('refreshToken', refreshToken)
        },
        CLEAR_TOKEN(state) {
            state.token = ''
            state.refreshToken = ''
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
        }
    },
    actions: {
        setToken({commit}, {token, refreshToken}) {
            commit('SET_TOKEN', token)
            commit('SET_REFRESH_TOKEN', refreshToken)
        },
        // 保存用户信息
        setUser({commit}, user) {
            commit('SET_USER', user)
        },
        clearToken({commit}) {
            commit('CLEAR_TOKEN')
        }
    },
    getters: {
        token: state => state.token,
        refreshToken: state => state.refreshToken,
        isAuthenticated: state => !!state.token,
        userId: state => state.user.id ?? 0
    },
    modules: {
        system,
        user,
        search
    }
})